import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { FormInputText } from '@/components/form/FormInputText';
import { PASSWORD_MIN_LENGTH, PASSWORD_POLICY_HINT } from '@/utils/passwordPolicyHelpers';

/* Account Setup
    username: '',
    password: '',
    reEnterPassword: '',
*/
export const AccountStep = () => {
    const { control, getValues } = useFormContext();

    return (
        <Grid container spacing={3}>
            <Grid container spacing={3} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="username"
                        control={control}
                        label="Username"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'username',
                            autoComplete: 'username',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                                minLength: {
                                    value: 5,
                                    message: 'Minimum 5 characters',
                                },
                                pattern: {
                                    value: /^\S*$/,
                                    message: 'Username cannot contain spaces',
                                },
                            },
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="password"
                        control={control}
                        label="Password"
                        defaultHelperText={PASSWORD_POLICY_HINT}
                        inputFieldProps={{
                            size: 'medium',
                            type: 'password',
                            id: 'password',
                            autoComplete: 'new-password',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                                minLength: {
                                    value: PASSWORD_MIN_LENGTH,
                                    message: `Minimum ${PASSWORD_MIN_LENGTH} characters`,
                                },
                            },
                        }}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="reEnterPassword"
                        control={control}
                        label="Reenter New Password"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'password',
                            id: 'reEnterPassword',
                            autoComplete: 'new-password',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                                validate: (value: string) =>
                                    value === getValues('password') || 'Passwords do not match',
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};
